import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchSectionService {

  constructor() { }

  /** compare Pickup and DropOff Time and then return:
   *  *0 if equals
   *  *1 if PickUp is Greater
   *  *-1 if DropOff Greater
  */

  comparePickUpAndDropOffTime(pickUpTime, dropOffTime):number {

    //Get PickUpTime and MinValidTime as String
    var _pickUpTime = pickUpTime + "";
    var _dropOffTime = dropOffTime + "";

    //TO handle am|AM compination
    _pickUpTime = _pickUpTime.toLocaleLowerCase();
    _dropOffTime = _dropOffTime.toLocaleLowerCase();

    //This to add 0 at the begging if the first section contains only one
    // E.g: 9:00am will convert to 09:00am
    let firstSection = _pickUpTime.split(':')[0]
    if (firstSection != null && firstSection.length < 2) {
      _pickUpTime = '0' + _pickUpTime;
    }

    firstSection = _dropOffTime.split(':')[0]
    if (firstSection != null && firstSection.length < 2) {
      _dropOffTime = '0' + _dropOffTime;
    }

    //Replace the am with a minus (-) to make the comparison
    if (_pickUpTime.includes('am')) {
      _pickUpTime = '-' + _pickUpTime.replace('am', '');

    }
    else {
      _pickUpTime = _pickUpTime.replace('pm', '');
    }

    //Replace the am with a minus (-) to make the comparison
    if (_dropOffTime.includes('am')) {
      _dropOffTime = '-' + _dropOffTime.replace('am', '');

    }
    else {
      _dropOffTime = _dropOffTime.replace('pm', '');
    }

    //Compare the two time
    if (_pickUpTime == _dropOffTime) {
      return 0;
    }
    else if (_pickUpTime > _dropOffTime) {
      return 1;
    }
    else {
      return -1;
    }

  }

}
